import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { SubmitHandler, useForm } from 'react-hook-form'

import { Button } from '../../../common/components/Button'
import useText from '../../../common/hooks/useText'

const SButtonWrapper = styled.div`
    display: flex;
    gap: 4px;
    justify-content: flex-end;
`
type Filter = { name?: string; partnerName?: string }

export type CompanySearchWidgetProps = {
    onSearch: (filter: Filter) => void
    onClear: () => void
}

export const CompanySearchWidget: FC<CompanySearchWidgetProps> = memo(function ({ onSearch, onClear }) {
    const text = useText()
    const {
        register,
        handleSubmit,
        reset,
        formState: { isSubmitting },
    } = useForm<Filter>()

    const onSubmit: SubmitHandler<Filter> = async ({ name, partnerName }) => {
        await onSearch({ name, partnerName })
    }

    const handleClear = () => {
        reset()
        onClear()
    }

    return (
        <div className="margin-bottom-small row">
            <form name="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
                <div className="col-xs-12 col-md-4">
                    <div className="form-group">
                        <input
                            {...register('name')}
                            placeholder="Name"
                            className="form-control"
                            data-testid="company-name-input"
                        />
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="form-group">
                        <input
                            {...register('partnerName')}
                            placeholder="Partner"
                            className="form-control"
                            data-testid="partner-name-input"
                        />
                    </div>
                    <SButtonWrapper>
                        <Button
                            loading={isSubmitting}
                            type="submit"
                            size="sm"
                            label={text('btnSearch')}
                            data-testid="search-btn"
                        />

                        <Button size="sm" label={text('btnClear')} onClick={handleClear} data-testid="clear-btn" />
                    </SButtonWrapper>
                </div>
            </form>
        </div>
    )
})
